import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, TemplateRef, Renderer2, ChangeDetectorRef, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

import * as Utils from '@shared/core/utils';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit, AfterViewInit {
    public hasContent: boolean = false;
    public isHovering: boolean;

    /* Circle button */
    @Input() public isActive: boolean = false;
    @Input() public icon: string;
    @Input() public iconHover: string;
    @Input() public hoverShadow: boolean = true;

    @Input() public form: string = null;
    @Input() public left: TemplateRef<any>;
    @Input() public right: TemplateRef<any>;
    @Input() public badgeLeft: string | number = null;
    @Input() public badgeRight: string | number = null;
    @Input() public badgePosition: 'tl' | 'tr' | 'bl' | 'br' = null;
    @Input() public badgeSize: OLO.Components.BADGE_SIZE = 'sm';
    @Input() public classes: string = `btn`;
    // @Input() public extend: boolean = false; /* Full width of current area */
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public feel: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL = 'primary';
    @Input() public isAsync: boolean = false;
    @Input() public inverted: boolean = false;
    @Input() public iconLeft: string = null;
    @Input() public iconRight: string = null;
    @Input() public title: string = '';
    @Input() public role: string = null;
    @Input() public disabled: boolean = false;
    @Input() public loading: OLO.Components.LOADING_STATUS = null;
    @Input() public width: OLO.Components.BUTTON_WIDTH = 'normal';
    @Input() public paddings: boolean = true;
    @Input() public tabindex: number = 0;

    /* For routerLink */
    @Input() public routerLink: string | any[];
    @Input() public queryParams: { [k: string]: any; };
    @Input() public fragment: string;
    @Input() public queryParamsHandling: any; /* QueryParamsHandling */
    @Input() public preserveFragment: boolean;
    @Input() public skipLocationChange: boolean;
    @Input() public replaceUrl: boolean;
    @Input() public state?: { [k: string]: any; };

    /* For btn */
    @Input() public for: string;
    @Input() public type: string = 'button';
    @Input() public name: string = '';

    @Output() public onClick: EventEmitter<Event> = new EventEmitter(this.isAsync);

    /*  */
    @Input() public emphasis: boolean = false;

    @ViewChild('content', { static: true }) public content: ElementRef;

    constructor(
        public renderer2: Renderer2,
        public elementRef: ElementRef,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        /* Regular buttons */
        if (this.width) {
            this.renderer2.addClass(this.elementRef.nativeElement, `-width-${this.width}`);
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.content && this.content.nativeElement && this.content.nativeElement.childNodes.length) {
                this.hasContent = true;
                this.changeDetectorRef.detectChanges();
            }
        }, 0);
    }

    public handleButtonClick($event: Event, target?: HTMLElement): void {
        if (this.disabled) {
            $event.preventDefault();
            return;
        }

        this.onClick.emit($event);

        if (Utils.Devices.isMobile() && target) {
            setTimeout(() => {

                target.blur();
                this.isHovering = false;
            }, 250);
        }
    }

    public handleMouseEnter($event: Event): void {
        if (Utils.Devices.isMobile()) return;
        this.isHovering = true;
    }

    public handleMouseLeave($event: Event): void {
        if (Utils.Devices.isMobile()) return;
        this.isHovering = false;
    }
}
